import React, { useEffect, useRef, useState } from "react";

function StatNum({ value, suffix, active }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!active) {
      setCount(0); // Reset when section leaves viewport
      return;
    }

    let current = 0;

    const timer = setInterval(() => {
      current += value / 50;

      if (current >= value) {
        setCount(value);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, 30);

    return () => clearInterval(timer);
  }, [active, value]);

  return (
    <span className="ws-stat-num_blue">
      {count.toLocaleString()}
      <span> {suffix}</span>
    </span>
  );
}

export function WinnersStatsBlue() {
  const sectionRef = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setActive(entry.isIntersecting);
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const stats = [
    { value: 1, suffix: "Lakh+", label: "Active properties listed" },
    { value: 25, suffix: "Crore", label: "Total property value" },
    { value: 20, suffix: "Cities", label: "Premium urban markets" },
    { value: 1600, suffix: "Localities", label: "Neighbourhoods covered" },
  ];

  return (
    <section className="ws-stats_blue" ref={sectionRef}>
      <div className="ws-stats-grid_blue">
        {stats.map((s) => (
          <div key={s.label} className="ws-stat_blue">
            <StatNum
              value={s.value}
              suffix={s.suffix}
              active={active}
            />
            <div className="ws-stat-label_blue">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}